import { render, staticRenderFns } from "./deduction.vue?vue&type=template&id=4c3c37b0"
import script from "./deduction.vue?vue&type=script&lang=js"
export * from "./deduction.vue?vue&type=script&lang=js"
import style0 from "./deduction.vue?vue&type=style&index=0&id=4c3c37b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports